import BigNumber from 'bignumber.js';
BigNumber.config({ EXPONENTIAL_AT: 1e9, ROUNDING_MODE: BigNumber.ROUND_FLOOR });

/**
 *
 * @param {BigNumber | String | Number} balance
 * @param {BigNumber | String | Number} decimals
 * @param {Number} precision
 * @returns {String} fraction
 */
export const toFraction = (balance, decimals, precision = 8) => {
  try {
    const numerator = new BigNumber(balance.toString());
    const denominator = new BigNumber(10).exponentiatedBy(decimals);
    const value = numerator.dividedBy(denominator);
    if (precision === Infinity) {
      return value.toString();
    }
    return value.decimalPlaces(precision).toString();
  } catch (_) {
    return '0';
  }
};

/**
 *
 * @param {BigNumber | String | Number} balance
 * @param {BigNumber | String | Number} decimals
 * @param {Number} precision
 * @returns {String} balance
 */
export const fromFraction = (balance, decimals, precision = 8) => {
  try {
    balance = new BigNumber(balance.toString());
    decimals = new BigNumber(10).exponentiatedBy(decimals);
    return balance.multipliedBy(decimals).decimalPlaces(precision).toString();
  } catch (_) {
    return '0';
  }
};

export const BigNumberComparision = {
  GREATER: 1,
  LESSER: -1,
  EQUAL: 0,
  NAN: null,
};

/**
 *
 * @param {BigNumber | String | Number} balance entire value
 * @param {Number} precision no of decimal places to be displayed
 * @returns {string} string
 */
export const displayBalance = (
  balance,
  precision = 4,
  showDecimals = false
) => {
  try {
    balance = new BigNumber(balance);
    if (balance.isNaN()) return '';
    const truncatedBalance = new BigNumber(balance).decimalPlaces(precision);
    if (truncatedBalance.isZero() && !balance.isZero())
      return `< ${(0).toFixed(precision - 1)}1`;
    const slices = truncatedBalance.toString().split('.');
    const wholeNumber = slices[0];
    let formattedNumber = Array.from(wholeNumber)
      .reverse()
      .reduce((prev, curr, index) => {
        const next = prev.slice();
        if (index % 3 === 0 && index !== 0) {
          next.push(',');
        }
        next.push(curr);
        return next;
      }, [])
      .reverse()
      .join('');
    if (slices.length === 2 && balance.toString().split('.').length === 2) {
      if (!showDecimals) {
        return `${formattedNumber}`;
      } else {
        const formattedDecimals = slices[1];
        return `${formattedNumber}.${formattedDecimals}`;
      }
    }
    return formattedNumber;
  } catch (_) {
    return '0';
  }
};

/**
 *
 * @param {BigNumber | String | Number} number to be tested if zero
 * @returns {Boolean} boolean
 */
export const isZero = (number) => {
  return new BigNumber(number).isZero();
};

/**
 *
 * @param {BigNumber | String | Number} share
 * @param {BigNumber | String | Number} total
 * @returns {BigNumber}
 */
export const toPercent = (share, total) => {
  return new BigNumber(share).multipliedBy(100).dividedBy(total).toString();
};
